import { Carousel, Card } from "./AppleCardsCarousel"

const DummyContent = ({ team }) => {
  const descriptions = {
    Automation:
      "From hardware integration to autonomous control, our Automation team builds the mechanical and electronic core of our drones — ensuring every takeoff is smooth and every landing perfect.",
    Technical:
      "The Technical team turns complex challenges into working innovations. From flight controllers to simulation, this is where the engineering magic happens.",
    Outreach:
      "The Outreach team showcases Aeronauts to the world — managing events, collaborations, and our digital presence to inspire the next generation of innovators.",
    DSA:
      "Focused on logic, precision, and efficiency — the DSA team handles algorithms, data structures, and control systems that power our drone intelligence.",
    Magnet:
      "The Magnet team crafts beautiful, functional digital products — from web platforms to mobile apps — connecting Aeronauts with the NSUT community.",
    Research:
      "Our Research & Innovation team explores new drone technologies, from swarm flight to AI-driven stabilization — pushing boundaries every day.",
  }

  return (
    <div className="bg-[#F5F5F7] dark:bg-neutral-800 p-8 md:p-14 rounded-3xl mb-4">
      <p className="text-neutral-600 dark:text-neutral-400 text-base md:text-2xl max-w-3xl mx-auto">
        <span className="font-bold text-neutral-700 dark:text-neutral-200">{team}</span>{" "}
        — {descriptions[team] || "Building the future of Aeronautics at NSUT."}
      </p>
      <img
        src="https://images.unsplash.com/photo-1508612761958-e931d843bddb?w=1600&q=80&auto=format&fit=crop"
        alt="Drone mockup"
        className="md:w-1/2 md:h-1/2 h-full w-full mx-auto object-contain mt-8"
      />
    </div>
  )
}

const data = [
  {
    category: "Automation Team",
    title: "Where mechanics meet intelligence.",
    src: "https://res.cloudinary.com/dzisiobww/image/upload/v1761764665/pexels-photo-3913031_tq2221.jpg",
    content: <DummyContent team="Automation" />,
  },
  {
    category: "Technical Team",
    title: "Engineering the future of flight.",
    src: "https://res.cloudinary.com/dzisiobww/image/upload/v1761764665/pexels-photo-8355224_jzh7u1.jpg",
    content: <DummyContent team="Technical" />,
  },
  {
    category: "Outreach Team",
    title: "Spreading our wings beyond the sky.",
    src: "https://res.cloudinary.com/dzisiobww/image/upload/v1761764665/pexels-photo-6400301_wepsrr.jpg",
    content: <DummyContent team="Outreach" />,
  },
  {
    category: "DSA Team",
    title: "Coding precision, flying perfection.",
    src: "https://res.cloudinary.com/dzisiobww/image/upload/v1761764666/pexels-photo-5816283_tukqh6.jpg",
    content: <DummyContent team="DSA" />,
  },
  {
    category: "Magnet Team",
    title: "Powering the digital core of Aeronauts.",
    src: "https://res.cloudinary.com/dzisiobww/image/upload/v1761764664/photo-1519389950473-47ba0277781c_hd3kga.avif",
    content: <DummyContent team="Magnet" />,
  },
  {
    category: "Research & Innovation",
    title: "Exploring new frontiers in drone tech.",
    src: "https://res.cloudinary.com/dzisiobww/image/upload/v1761764665/pexels-photo-34476267_pwqb2y.jpg",
    content: <DummyContent team="Research" />,
  },
]

export default function AppleCardsCarouselDemo() {
  const cards = data.map((card, index) => (
    <Card key={card.src} card={card} index={index} />
  ))

  return (
    <div className="w-full h-full py-20">
      <h2 className="max-w-7xl pl-4 mx-auto text-xl md:text-5xl font-bold text-neutral-800 dark:text-neutral-200 flex flex-wrap items-center gap-3">
  Meet the{" "}
  <span className="relative inline-block px-4 py-2 rounded-2xl">
    <span className="relative z-10 text-transparent bg-clip-text bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500">
      Aeronauts Departments
    </span>
    <span className="absolute inset-0 bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 blur-xl opacity-50 -z-10 rounded-2xl"></span>
  </span>
</h2>

      <Carousel items={cards} />
    </div>
  )
}
